import React from 'react'

const FCompany = () => {
  return (
    <div className='footer-column-container'>
      <div className='footer-container-1 footer-heading'>
        <h3>COMPANY</h3>
      </div>
      <div className='footer-container-1'>
        <p>About</p>
      </div>
      <div className='footer-container-1'>
        <p>Press</p>
      </div>
      <div className='footer-container-1'>
        <p>Work Here</p>
      </div>
      <div className='footer-container-1'>
        <p>Legal</p>
      </div>
      <div className='footer-container-1'>
        <p>Privacy Policy</p>
      </div>
      <div className='footer-container-1'>
        <p>Terms & Service</p>
      </div>
      <div className='footer-container-1'>
        <p>Contact Us</p>
      </div>
      <div className='footer-container-1'>
        <p>Cookie Policy</p>
      </div>
    </div>
  )
}

export default FCompany